export default __webpack_public_path__ + "static/media/Layer 11.6d9f1dc6.png";